"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _acquavivaPicena = _interopRequireDefault(require("./25_group_2023_12_12/acquaviva-picena"));

var _aglianoTerme = _interopRequireDefault(require("./25_group_2023_12_12/agliano-terme"));

var _agugliaro = _interopRequireDefault(require("./25_group_2023_12_12/agugliaro"));

var _aielloDelSabato = _interopRequireDefault(require("./25_group_2023_12_12/aiello-del-sabato"));

var _albinea = _interopRequireDefault(require("./25_group_2023_12_12/albinea"));

var _alife = _interopRequireDefault(require("./25_group_2023_12_12/alife"));

var _altopascio = _interopRequireDefault(require("./25_group_2023_12_12/altopascio"));

var _alvignano = _interopRequireDefault(require("./25_group_2023_12_12/alvignano"));

var _alvito = _interopRequireDefault(require("./25_group_2023_12_12/alvito"));

var _andornoMicca = _interopRequireDefault(require("./25_group_2023_12_12/andorno-micca"));

var _apecchio = _interopRequireDefault(require("./25_group_2023_12_12/apecchio"));

var _aragona = _interopRequireDefault(require("./25_group_2023_12_12/aragona"));

var _ardesio = _interopRequireDefault(require("./25_group_2023_12_12/ardesio"));

var _arezzo = _interopRequireDefault(require("./25_group_2023_12_12/arezzo"));

var _barbaranoMossano = _interopRequireDefault(require("./25_group_2023_12_12/barbarano-mossano"));

var _bardi = _interopRequireDefault(require("./25_group_2023_12_12/bardi"));

var _bertinoro = _interopRequireDefault(require("./25_group_2023_12_12/bertinoro"));

var _bibbona = _interopRequireDefault(require("./25_group_2023_12_12/bibbona"));

var _biella = _interopRequireDefault(require("./25_group_2023_12_12/biella"));

var _borgoPace = _interopRequireDefault(require("./25_group_2023_12_12/borgo-pace"));

var _borno = _interopRequireDefault(require("./25_group_2023_12_12/borno"));

var _boscoMarengo = _interopRequireDefault(require("./25_group_2023_12_12/bosco-marengo"));

var _brisighella = _interopRequireDefault(require("./25_group_2023_12_12/brisighella"));

var _broccostella = _interopRequireDefault(require("./25_group_2023_12_12/broccostella"));

var _caltrano = _interopRequireDefault(require("./25_group_2023_12_12/caltrano"));

var _calviRisorta = _interopRequireDefault(require("./25_group_2023_12_12/calvi-risorta"));

var _campagnatico = _interopRequireDefault(require("./25_group_2023_12_12/campagnatico"));

var _campigliaCervo = _interopRequireDefault(require("./25_group_2023_12_12/campiglia-cervo"));

var _camugnano = _interopRequireDefault(require("./25_group_2023_12_12/camugnano"));

var _canaleMonterano = _interopRequireDefault(require("./25_group_2023_12_12/canale-monterano"));

var _canistro = _interopRequireDefault(require("./25_group_2023_12_12/canistro"));

var _capreseMichelangelo = _interopRequireDefault(require("./25_group_2023_12_12/caprese-michelangelo"));

var _carini = _interopRequireDefault(require("./25_group_2023_12_12/carini"));

var _carpanetoPiacentino = _interopRequireDefault(require("./25_group_2023_12_12/carpaneto-piacentino"));

var _casina = _interopRequireDefault(require("./25_group_2023_12_12/casina"));

var _castelDAiano = _interopRequireDefault(require("./25_group_2023_12_12/castel-d-aiano"));

var _castelDiCasio = _interopRequireDefault(require("./25_group_2023_12_12/castel-di-casio"));

var _castelGiorgio = _interopRequireDefault(require("./25_group_2023_12_12/castel-giorgio"));

var _castelSanPietroRomano = _interopRequireDefault(require("./25_group_2023_12_12/castel-san-pietro-romano"));

var _castelbianco = _interopRequireDefault(require("./25_group_2023_12_12/castelbianco"));

var _casteldelci = _interopRequireDefault(require("./25_group_2023_12_12/casteldelci"));

var _castelforte = _interopRequireDefault(require("./25_group_2023_12_12/castelforte"));

var _castelvenere = _interopRequireDefault(require("./25_group_2023_12_12/castelvenere"));

var _castiglioneDiGarfagnana = _interopRequireDefault(require("./25_group_2023_12_12/castiglione-di-garfagnana"));

var _catignano = _interopRequireDefault(require("./25_group_2023_12_12/catignano"));

var _cepagatti = _interopRequireDefault(require("./25_group_2023_12_12/cepagatti"));

var _ceppaloni = _interopRequireDefault(require("./25_group_2023_12_12/ceppaloni"));

var _chiusdino = _interopRequireDefault(require("./25_group_2023_12_12/chiusdino"));

var _cicerale = _interopRequireDefault(require("./25_group_2023_12_12/cicerale"));

var _colfelice = _interopRequireDefault(require("./25_group_2023_12_12/colfelice"));

var _collecorvino = _interopRequireDefault(require("./25_group_2023_12_12/collecorvino"));

var _conflenti = _interopRequireDefault(require("./25_group_2023_12_12/conflenti"));

var _corinaldo = _interopRequireDefault(require("./25_group_2023_12_12/corinaldo"));

var _cornoGiovine = _interopRequireDefault(require("./25_group_2023_12_12/corno-giovine"));

var _crespadoro = _interopRequireDefault(require("./25_group_2023_12_12/crespadoro"));

var _cupello = _interopRequireDefault(require("./25_group_2023_12_12/cupello"));

var _dicomano = _interopRequireDefault(require("./25_group_2023_12_12/dicomano"));

var _dugenta = _interopRequireDefault(require("./25_group_2023_12_12/dugenta"));

var _elice = _interopRequireDefault(require("./25_group_2023_12_12/elice"));

var _empoli = _interopRequireDefault(require("./25_group_2023_12_12/empoli"));

var _farini = _interopRequireDefault(require("./25_group_2023_12_12/farini"));

var _ferrandina = _interopRequireDefault(require("./25_group_2023_12_12/ferrandina"));

var _ficarra = _interopRequireDefault(require("./25_group_2023_12_12/ficarra"));

var _fidenza = _interopRequireDefault(require("./25_group_2023_12_12/fidenza"));

var _figlineVegliaturo = _interopRequireDefault(require("./25_group_2023_12_12/figline-vegliaturo"));

var _filettino = _interopRequireDefault(require("./25_group_2023_12_12/filettino"));

var _fiumalbo = _interopRequireDefault(require("./25_group_2023_12_12/fiumalbo"));

var _force = _interopRequireDefault(require("./25_group_2023_12_12/force"));

var _frassinoro = _interopRequireDefault(require("./25_group_2023_12_12/frassinoro"));

var _gaggioMontano = _interopRequireDefault(require("./25_group_2023_12_12/gaggio-montano"));

var _gattatico = _interopRequireDefault(require("./25_group_2023_12_12/gattatico"));

var _gavignano = _interopRequireDefault(require("./25_group_2023_12_12/gavignano"));

var _gazzola = _interopRequireDefault(require("./25_group_2023_12_12/gazzola"));

var _giussano = _interopRequireDefault(require("./25_group_2023_12_12/giussano"));

var _graglia = _interopRequireDefault(require("./25_group_2023_12_12/graglia"));

var _grizzanaMorandi = _interopRequireDefault(require("./25_group_2023_12_12/grizzana-morandi"));

var _isolaDAsti = _interopRequireDefault(require("./25_group_2023_12_12/isola-d-asti"));

var _labro = _interopRequireDefault(require("./25_group_2023_12_12/labro"));

var _laion = _interopRequireDefault(require("./25_group_2023_12_12/laion"));

var _lavarone = _interopRequireDefault(require("./25_group_2023_12_12/lavarone"));

var _londa = _interopRequireDefault(require("./25_group_2023_12_12/londa"));

var _maiolatiSpontini = _interopRequireDefault(require("./25_group_2023_12_12/maiolati-spontini"));

var _majano = _interopRequireDefault(require("./25_group_2023_12_12/majano"));

var _mammola = _interopRequireDefault(require("./25_group_2023_12_12/mammola"));

var _mansue = _interopRequireDefault(require("./25_group_2023_12_12/mansue"));

var _maranoSulPanaro = _interopRequireDefault(require("./25_group_2023_12_12/marano-sul-panaro"));

var _marone = _interopRequireDefault(require("./25_group_2023_12_12/marone"));

var _marsala = _interopRequireDefault(require("./25_group_2023_12_12/marsala"));

var _masio = _interopRequireDefault(require("./25_group_2023_12_12/masio"));

var _melazzo = _interopRequireDefault(require("./25_group_2023_12_12/melazzo"));

var _moimacco = _interopRequireDefault(require("./25_group_2023_12_12/moimacco"));

var _monreale = _interopRequireDefault(require("./25_group_2023_12_12/monreale"));

var _monteSanBiagio = _interopRequireDefault(require("./25_group_2023_12_12/monte-san-biagio"));

var _monteSanPietro = _interopRequireDefault(require("./25_group_2023_12_12/monte-san-pietro"));

var _montefalconeAppennino = _interopRequireDefault(require("./25_group_2023_12_12/montefalcone-appennino"));

var _montese = _interopRequireDefault(require("./25_group_2023_12_12/montese"));

var _montesilvano = _interopRequireDefault(require("./25_group_2023_12_12/montesilvano"));

var _montottone = _interopRequireDefault(require("./25_group_2023_12_12/montottone"));

var _monzuno = _interopRequireDefault(require("./25_group_2023_12_12/monzuno"));

var _morfasso = _interopRequireDefault(require("./25_group_2023_12_12/morfasso"));

var _morraDeSanctis = _interopRequireDefault(require("./25_group_2023_12_12/morra-de-sanctis"));

var _moscufo = _interopRequireDefault(require("./25_group_2023_12_12/moscufo"));

var _nerviano = _interopRequireDefault(require("./25_group_2023_12_12/nerviano"));

var _nevianoDegliArduini = _interopRequireDefault(require("./25_group_2023_12_12/neviano-degli-arduini"));

var _novellara = _interopRequireDefault(require("./25_group_2023_12_12/novellara"));

var _noventaDiPiave = _interopRequireDefault(require("./25_group_2023_12_12/noventa-di-piave"));

var _nusco = _interopRequireDefault(require("./25_group_2023_12_12/nusco"));

var _orsogna = _interopRequireDefault(require("./25_group_2023_12_12/orsogna"));

var _ozzanoDellEmilia = _interopRequireDefault(require("./25_group_2023_12_12/ozzano-dell-emilia"));

var _palaia = _interopRequireDefault(require("./25_group_2023_12_12/palaia"));

var _pareto = _interopRequireDefault(require("./25_group_2023_12_12/pareto"));

var _parrano = _interopRequireDefault(require("./25_group_2023_12_12/parrano"));

var _parzanica = _interopRequireDefault(require("./25_group_2023_12_12/parzanica"));

var _paviaDiUdine = _interopRequireDefault(require("./25_group_2023_12_12/pavia-di-udine"));

var _pavulloNelFrignano = _interopRequireDefault(require("./25_group_2023_12_12/pavullo-nel-frignano"));

var _piadenaDrizzona = _interopRequireDefault(require("./25_group_2023_12_12/piadena-drizzona"));

var _pianaCrixia = _interopRequireDefault(require("./25_group_2023_12_12/piana-crixia"));

var _picinisco = _interopRequireDefault(require("./25_group_2023_12_12/picinisco"));

var _pienza = _interopRequireDefault(require("./25_group_2023_12_12/pienza"));

var _pietrarubbia = _interopRequireDefault(require("./25_group_2023_12_12/pietrarubbia"));

var _pizzoli = _interopRequireDefault(require("./25_group_2023_12_12/pizzoli"));

var _podenzana = _interopRequireDefault(require("./25_group_2023_12_12/podenzana"));

var _podenzano = _interopRequireDefault(require("./25_group_2023_12_12/podenzano"));

var _ponteBuggianese = _interopRequireDefault(require("./25_group_2023_12_12/ponte-buggianese"));

var _ponte = _interopRequireDefault(require("./25_group_2023_12_12/ponte"));

var _portoAzzurro = _interopRequireDefault(require("./25_group_2023_12_12/porto-azzurro"));

var _portoferraio = _interopRequireDefault(require("./25_group_2023_12_12/portoferraio"));

var _prignanoSullaSecchia = _interopRequireDefault(require("./25_group_2023_12_12/prignano-sulla-secchia"));

var _raddaInChianti = _interopRequireDefault(require("./25_group_2023_12_12/radda-in-chianti"));

var _roccaDEvandro = _interopRequireDefault(require("./25_group_2023_12_12/rocca-d-evandro"));

var _roccamontepiano = _interopRequireDefault(require("./25_group_2023_12_12/roccamontepiano"));

var _roncoferraro = _interopRequireDefault(require("./25_group_2023_12_12/roncoferraro"));

var _rufina = _interopRequireDefault(require("./25_group_2023_12_12/rufina"));

var _ruvoDiPuglia = _interopRequireDefault(require("./25_group_2023_12_12/ruvo-di-puglia"));

var _sanBenedettoValDiSambro = _interopRequireDefault(require("./25_group_2023_12_12/san-benedetto-val-di-sambro"));

var _sanMarcello = _interopRequireDefault(require("./25_group_2023_12_12/san-marcello"));

var _sanMicheleDiSerino = _interopRequireDefault(require("./25_group_2023_12_12/san-michele-di-serino"));

var _sanPietroInGu = _interopRequireDefault(require("./25_group_2023_12_12/san-pietro-in-gu"));

var _sanPossidonio = _interopRequireDefault(require("./25_group_2023_12_12/san-possidonio"));

var _sanVittoreDelLazio = _interopRequireDefault(require("./25_group_2023_12_12/san-vittore-del-lazio"));

var _santAndreaApostoloDelloIonio = _interopRequireDefault(require("./25_group_2023_12_12/sant-andrea-apostolo-dello-ionio"));

var _santAngeloRomano = _interopRequireDefault(require("./25_group_2023_12_12/sant-angelo-romano"));

var _santopadre = _interopRequireDefault(require("./25_group_2023_12_12/santopadre"));

var _sarsina = _interopRequireDefault(require("./25_group_2023_12_12/sarsina"));

var _sassoMarconi = _interopRequireDefault(require("./25_group_2023_12_12/sasso-marconi"));

var _savoca = _interopRequireDefault(require("./25_group_2023_12_12/savoca"));

var _scicli = _interopRequireDefault(require("./25_group_2023_12_12/scicli"));

var _sellano = _interopRequireDefault(require("./25_group_2023_12_12/sellano"));

var _serrastretta = _interopRequireDefault(require("./25_group_2023_12_12/serrastretta"));

var _tarano = _interopRequireDefault(require("./25_group_2023_12_12/tarano"));

var _terenzo = _interopRequireDefault(require("./25_group_2023_12_12/terenzo"));

var _tiglieto = _interopRequireDefault(require("./25_group_2023_12_12/tiglieto"));

var _tivoli = _interopRequireDefault(require("./25_group_2023_12_12/tivoli"));

var _toano = _interopRequireDefault(require("./25_group_2023_12_12/toano"));

var _torrice = _interopRequireDefault(require("./25_group_2023_12_12/torrice"));

var _traversetolo = _interopRequireDefault(require("./25_group_2023_12_12/traversetolo"));

var _trecastelli = _interopRequireDefault(require("./25_group_2023_12_12/trecastelli"));

var _trecchina = _interopRequireDefault(require("./25_group_2023_12_12/trecchina"));

var _urbania = _interopRequireDefault(require("./25_group_2023_12_12/urbania"));

var _vaglia = _interopRequireDefault(require("./25_group_2023_12_12/vaglia"));

var _vaiano = _interopRequireDefault(require("./25_group_2023_12_12/vaiano"));

var _vallata = _interopRequireDefault(require("./25_group_2023_12_12/vallata"));

var _valliDelPasubio = _interopRequireDefault(require("./25_group_2023_12_12/valli-del-pasubio"));

var _varsi = _interopRequireDefault(require("./25_group_2023_12_12/varsi"));

var _venafro = _interopRequireDefault(require("./25_group_2023_12_12/venafro"));

var _venezia = _interopRequireDefault(require("./25_group_2023_12_12/venezia"));

var _vernasca = _interopRequireDefault(require("./25_group_2023_12_12/vernasca"));

var _vibonati = _interopRequireDefault(require("./25_group_2023_12_12/vibonati"));

var _villaSantoStefano = _interopRequireDefault(require("./25_group_2023_12_12/villa-santo-stefano"));

var _volterra = _interopRequireDefault(require("./25_group_2023_12_12/volterra"));

var _zambrone = _interopRequireDefault(require("./25_group_2023_12_12/zambrone"));

var _zocca = _interopRequireDefault(require("./25_group_2023_12_12/zocca"));

var _zolaPredosa = _interopRequireDefault(require("./25_group_2023_12_12/zola-predosa"));

var _zone = _interopRequireDefault(require("./25_group_2023_12_12/zone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _acquavivaPicena["default"], {}, _aglianoTerme["default"], {}, _agugliaro["default"], {}, _aielloDelSabato["default"], {}, _albinea["default"], {}, _alife["default"], {}, _altopascio["default"], {}, _alvignano["default"], {}, _alvito["default"], {}, _andornoMicca["default"], {}, _apecchio["default"], {}, _aragona["default"], {}, _ardesio["default"], {}, _arezzo["default"], {}, _barbaranoMossano["default"], {}, _bardi["default"], {}, _bertinoro["default"], {}, _bibbona["default"], {}, _biella["default"], {}, _borgoPace["default"], {}, _borno["default"], {}, _brisighella["default"], {}, _boscoMarengo["default"], {}, _broccostella["default"], {}, _caltrano["default"], {}, _calviRisorta["default"], {}, _campagnatico["default"], {}, _campigliaCervo["default"], {}, _camugnano["default"], {}, _canaleMonterano["default"], {}, _canistro["default"], {}, _capreseMichelangelo["default"], {}, _carini["default"], {}, _carpanetoPiacentino["default"], {}, _casina["default"], {}, _castelDAiano["default"], {}, _castelDiCasio["default"], {}, _castelGiorgio["default"], {}, _castelSanPietroRomano["default"], {}, _castelbianco["default"], {}, _casteldelci["default"], {}, _castelforte["default"], {}, _castelvenere["default"], {}, _castiglioneDiGarfagnana["default"], {}, _catignano["default"], {}, _cepagatti["default"], {}, _ceppaloni["default"], {}, _chiusdino["default"], {}, _cicerale["default"], {}, _colfelice["default"], {}, _collecorvino["default"], {}, _conflenti["default"], {}, _corinaldo["default"], {}, _cornoGiovine["default"], {}, _crespadoro["default"], {}, _cupello["default"], {}, _dicomano["default"], {}, _dugenta["default"], {}, _elice["default"], {}, _empoli["default"], {}, _farini["default"], {}, _ferrandina["default"], {}, _ficarra["default"], {}, _fidenza["default"], {}, _figlineVegliaturo["default"], {}, _filettino["default"], {}, _fiumalbo["default"], {}, _force["default"], {}, _frassinoro["default"], {}, _gaggioMontano["default"], {}, _gattatico["default"], {}, _gavignano["default"], {}, _gazzola["default"], {}, _giussano["default"], {}, _graglia["default"], {}, _grizzanaMorandi["default"], {}, _isolaDAsti["default"], {}, _labro["default"], {}, _laion["default"], {}, _lavarone["default"], {}, _londa["default"], {}, _maiolatiSpontini["default"], {}, _majano["default"], {}, _mammola["default"], {}, _mansue["default"], {}, _maranoSulPanaro["default"], {}, _marone["default"], {}, _marsala["default"], {}, _masio["default"], {}, _melazzo["default"], {}, _moimacco["default"], {}, _monreale["default"], {}, _monteSanBiagio["default"], {}, _monteSanPietro["default"], {}, _montefalconeAppennino["default"], {}, _montese["default"], {}, _montesilvano["default"], {}, _montottone["default"], {}, _monzuno["default"], {}, _morfasso["default"], {}, _morraDeSanctis["default"], {}, _moscufo["default"], {}, _nerviano["default"], {}, _nevianoDegliArduini["default"], {}, _novellara["default"], {}, _noventaDiPiave["default"], {}, _nusco["default"], {}, _orsogna["default"], {}, _ozzanoDellEmilia["default"], {}, _palaia["default"], {}, _pareto["default"], {}, _parrano["default"], {}, _parzanica["default"], {}, _paviaDiUdine["default"], {}, _pavulloNelFrignano["default"], {}, _piadenaDrizzona["default"], {}, _pianaCrixia["default"], {}, _picinisco["default"], {}, _pienza["default"], {}, _pietrarubbia["default"], {}, _pizzoli["default"], {}, _podenzana["default"], {}, _podenzano["default"], {}, _ponteBuggianese["default"], {}, _ponte["default"], {}, _portoAzzurro["default"], {}, _portoferraio["default"], {}, _prignanoSullaSecchia["default"], {}, _raddaInChianti["default"], {}, _roccaDEvandro["default"], {}, _roccamontepiano["default"], {}, _roncoferraro["default"], {}, _rufina["default"], {}, _ruvoDiPuglia["default"], {}, _sanBenedettoValDiSambro["default"], {}, _sanMarcello["default"], {}, _sanMicheleDiSerino["default"], {}, _sanPietroInGu["default"], {}, _sanPossidonio["default"], {}, _sanVittoreDelLazio["default"], {}, _santAndreaApostoloDelloIonio["default"], {}, _santAngeloRomano["default"], {}, _santopadre["default"], {}, _sarsina["default"], {}, _sassoMarconi["default"], {}, _savoca["default"], {}, _scicli["default"], {}, _sellano["default"], {}, _serrastretta["default"], {}, _tarano["default"], {}, _terenzo["default"], {}, _tiglieto["default"], {}, _tivoli["default"], {}, _toano["default"], {}, _torrice["default"], {}, _traversetolo["default"], {}, _trecastelli["default"], {}, _trecchina["default"], {}, _urbania["default"], {}, _vaglia["default"], {}, _vaiano["default"], {}, _vallata["default"], {}, _valliDelPasubio["default"], {}, _varsi["default"], {}, _venafro["default"], {}, _venezia["default"], {}, _vernasca["default"], {}, _vibonati["default"], {}, _villaSantoStefano["default"], {}, _volterra["default"], {}, _zambrone["default"], {}, _zocca["default"], {}, _zolaPredosa["default"], {}, _zone["default"]);

exports["default"] = _default;